import { createContext, useContext } from 'react';

import type { Subscription } from 'src/apiClients/queries';

export interface InstanceContextValue {
    subscription: Subscription;
    /** Row id to highlight when arriving from the TopBar typeahead. */
    highlightId?: string;
}

export const InstanceContext = createContext<InstanceContextValue | null>(null);

/**
 * Returns the subscription loaded by `InstanceDetailPage`. Must be called
 * from a component rendered inside the Instance Detail page.
 */
export const useInstance = (): InstanceContextValue => {
    const ctx = useContext(InstanceContext);
    if (!ctx) {
        throw new Error('useInstance must be used within InstanceDetailPage');
    }
    return ctx;
};
